module.exports = __webpack_public_path__ + "web/img/subject-desc.cdd28373.png";